module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/BlackHawkDown.f0562d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/BlackHawkDown.jpg
// module id = n1dV
// module chunks = 0